__turbopack_context__.v({
  "buttonWrapper": "AlQY3G_buttonWrapper",
  "closeButton": "AlQY3G_closeButton",
  "controlWrapper": "AlQY3G_controlWrapper",
  "controls": "AlQY3G_controls",
  "filtersButton": "AlQY3G_filtersButton",
  "openControls": "AlQY3G_openControls",
  "results": "AlQY3G_results",
  "scrollingContainer": "AlQY3G_scrollingContainer",
  "wrapper": "AlQY3G_wrapper",
});
